import { formatRelativeTime, getCanonicalLocale } from "@nextcloud/l10n";
import { toValue } from "@vueuse/core";
import { computed, ref, watchEffect, onUnmounted, readonly } from "vue";
import { r as register, e as t2, a as t } from "../chunks/_l10n-DSLCwJSN.mjs";
register(t2);
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const FEW_SECONDS_AGO = {
  long: t("a few seconds ago"),
  short: t("seconds ago"),
  // FOR TRANSLATORS: Shorter version of 'a few seconds ago'
  narrow: t("sec. ago")
  // FOR TRANSLATORS: If possible in your language an even shorter version of 'a few seconds ago'
};
function useFormatRelativeTime(timestamp = Date.now(), opts = {}) {
  let timeoutId;
  const date = computed(() => new Date(toValue(timestamp)));
  const options = computed(() => {
    const { language, relativeTime: relativeTime2, ignoreSeconds } = toValue(opts);
    return __spreadProps(__spreadValues(__spreadValues({}, language && { language }), relativeTime2 && { relativeTime: relativeTime2 }), {
      ignoreSeconds: ignoreSeconds ? FEW_SECONDS_AGO[relativeTime2 || "long"] : false
    });
  });
  const relativeTime = ref("");
  watchEffect(() => updateRelativeTime());
  function updateRelativeTime() {
    relativeTime.value = formatRelativeTime(date.value, options.value);
    if (toValue(opts).update !== false) {
      const diff = Math.abs(Date.now() - new Date(toValue(timestamp)).getTime());
      const interval = diff > 12e4 || options.value.ignoreSeconds ? Math.min(diff / 60, 18e5) : 1e3;
      timeoutId = window.setTimeout(updateRelativeTime, interval);
    }
  }
  onUnmounted(() => timeoutId && window.clearTimeout(timeoutId));
  return readonly(relativeTime);
}
function useFormatTime(timestamp, opts) {
  const options = computed(() => __spreadValues({
    locale: getCanonicalLocale(),
    format: { dateStyle: "short", timeStyle: "medium" }
  }, toValue(opts)));
  const formatter = computed(() => new Intl.DateTimeFormat(options.value.locale, options.value.format));
  return computed(() => formatter.value.format(toValue(timestamp)));
}
function useFormatDateTime(timestamp = Date.now(), opts = {}) {
  const formattedFullTime = useFormatTime(timestamp, opts);
  const relativeTime = useFormatRelativeTime(timestamp, computed(() => {
    const options = toValue(opts);
    return __spreadProps(__spreadValues({}, options), {
      relativeTime: typeof options.relativeTime === "string" ? options.relativeTime : "long"
    });
  }));
  const formattedTime = computed(() => toValue(opts).relativeTime !== false ? relativeTime.value : formattedFullTime.value);
  return {
    formattedTime,
    formattedFullTime
  };
}
export {
  useFormatDateTime,
  useFormatRelativeTime,
  useFormatTime
};
//# sourceMappingURL=useFormatDateTime.mjs.map
